import React, { useState, useEffect } from 'react';
import Menu from '../Menu'
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import '../App.css'



const MyCosts = () => {

    const [data, setData] = useState([]);
    const [categories, setCategories] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editRecord, setEditRecord] = useState(null);
    const [addRecord, setAddRecord] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const mytoken = sessionStorage.getItem('google_token');
    const { category } = useParams();
    const navigate = useNavigate();
    const [dateYMD, setDateYMD] = useState('');



    const [form2, setForm2] = useState({
        data_op: '',
        amount: '',
        categ_name: '',
        categ_id: '',
        categ_dest: '',
        details: '',
        subcateg: '',
        card: ''

    });

    const copyValues = () => {
        setForm2(editRecord);
    };



    const deleteRecord = async () => {
        const userConfirmed = window.confirm("Are you sure you want to delete ?");
        if (!userConfirmed) {
            return;
        }
        setIsLoading(true);
        setError(null);
        try {
            // Send PUT request to update the record
            const response = await fetch(`https://app64.heliohost.us/api/updateMyCosts.php?id=${editRecord.id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "AuthCode": mytoken
                }
            });

            if (!response.ok) {
                throw new Error("Failed to update the record.");
            }

            const updatedRecord = await response.json();

            // Update the local state
            setData((prevRecords) =>
                prevRecords.map((rec) =>
                    rec.id === updatedRecord.id ? updatedRecord : rec
                )
            );
            setEditRecord(null); // Close the form after saving
            window.location.reload();

        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };


    const clearAddValues = () => {

        setEditRecord(null);
        //copyValues();
        setForm2(editRecord);

    };

    const getMyCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };


    



    useEffect(() => {

        //console.log(`Parameter changed! Now showing item with ID: ${category}`);

        //const controller = new AbortController();
        //const signal = controller.signal;
        // Replace with your API endpoint

        setDateYMD(getMyCurrentDate());

        var apiUrl = 'https://app64.heliohost.us/api/getMyCosts.php?nrdays=60';
        if (typeof category !== "undefined") {
            apiUrl = 'https://app64.heliohost.us/api/getMyCosts.php?limit=50&categ_id=' + category;
        }
        //const apiUrl = 'http://localhost/api/getShareAlarms.php';
        
        
        console.log(`apiUrl: ${apiUrl}`);

        fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "AuthCode": mytoken
            }                        
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                return response.json();
            })
            .then((data) => {
                
                console.log(" ok receive data ");
                setData(data);
                setLoading(false);
                if (typeof category !== "undefined") {
                    console.log(" set fileter value  "+category);
                }
              
            })
            .catch((error) => {
                
                console.error("Error:", error);
                setError(error.message);
                setLoading(false);
                
            });

        // get Categories 
        apiUrl = "https://app64.heliohost.us/api/getMyCostCategories.php";
        fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "AuthCode": mytoken
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                return response.json();
            })
            .then((categories) => {
                setCategories(categories);
                setLoading(false);
                if (typeof category !== "undefined") {
                }
            })
            .catch((error) => {
                console.error("Error:", error);
                setError(error.message);
                setLoading(false);
            });
            
            return () => {
                //controller.abort("stop");
                ;
            };


    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty dependency array means this runs once on component mount

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }


    const handleEditClick = (record) => {
        setEditRecord(record); // Set the record to be edited
        //setSelectedCategory(record.categ_id);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditRecord({ ...editRecord, [name]: value });
    };


    const setCurrentDate = (e) => {
        setForm2((prevForm) => ({
            ...prevForm,
            data_op: getMyCurrentDate(),
        }));
    };


    const handleSelectChange = (event) => {
        const selectedValue = event.target.value;

        console.log("Selected Value:", selectedValue);
        if (selectedValue) {
            navigate(`/mycosts/${selectedValue}`);
            window.location.reload();
        }

    };


    const handleChangeAdd = (e) => {
        const { name, value } = e.target;
        setForm2({ ...form2, [name]: value });
    };

    const handleSave = async () => {
        setIsLoading(true);
        setError(null);
        try {
            // Send PUT request to update the record
            const response = await fetch(`https://app64.heliohost.us/api/updateMyCosts.php?id=${editRecord.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "AuthCode": mytoken
                },
                body: JSON.stringify(editRecord),
            });

            if (!response.ok) {
                throw new Error("Failed to update the record.");
            }

            const updatedRecord = await response.json();

            // Update the local state
            setData((prevRecords) =>
                prevRecords.map((rec) =>
                    rec.id === updatedRecord.id ? updatedRecord : rec
                )
            );
            setEditRecord(null); // Close the form after saving
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleAdd = async () => {
        setIsLoading(true);
        setError(null);
        setAddRecord("start adding");
        try {
            // Send PUT request to update the record
            const response = await fetch(`https://app64.heliohost.us/api/updateMyCosts.php?operation=add&id=${editRecord.id}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "AuthCode": mytoken
                },
                body: JSON.stringify(form2),
            });

            if (!response.ok) {
                setAddRecord("ok add record");
                throw new Error("Failed to update the record.");
            }

            const updatedRecord = await response.json();

            // Update the local state
            setData((prevRecords) =>
                prevRecords.map((rec) =>
                    rec.id === updatedRecord.id ? updatedRecord : rec
                )
            );
            //alert("ok added");
            //setEditRecord(null); // Close the form after saving

        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <div>
            <Menu />
            <h1 className="page-title">My Costs</h1>

            {editRecord && (
                <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setEditRecord(null)}>
                    <div className="modal-content">
                        <h2>
                            Edit Record
                            <button className="btn-close" onClick={() => setEditRecord(null)}>×</button>
                        </h2>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleSave();
                            }}
                        >
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Date</label>
                                    <input
                                        type="date"
                                        name="data_op"
                                        value={editRecord.data_op}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Currency</label>
                                    <select
                                        name="currency"
                                        value={editRecord.currency}
                                        onChange={handleInputChange}
                                    >
                                        <option value="RON">RON</option>
                                        <option value="EUR">EUR</option>
                                        <option value="USD">USD</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Amount</label>
                                    <input
                                        type="text"
                                        name="amount"
                                        value={editRecord.amount}
                                        onChange={handleInputChange}
                                        placeholder="0.00"
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Category ID</label>
                                    <select
                                        name="categ_id"
                                        value={editRecord.categ_id}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">--Select--</option>
                                        {categories.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.category}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Category Name</label>
                                    <input
                                        type="text"
                                        name="categ_name"
                                        value={editRecord.categ_name}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Destination</label>
                                    <input
                                        type="text"
                                        name="categ_dest"
                                        value={editRecord.categ_dest}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Details</label>
                                <input
                                    type="text"
                                    name="details"
                                    value={editRecord.details}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Subcategory</label>
                                    <input
                                        type="text"
                                        name="subcateg"
                                        value={editRecord.subcateg}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Card</label>
                                    <input
                                        type="text"
                                        name="card"
                                        value={editRecord.card}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            <div className="button-group">
                                <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                    {isLoading ? "Saving..." : "Save"}
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={() => setEditRecord(null)}>
                                    Cancel
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={copyValues}>
                                    Clone
                                </button>
                                <button type="button" className="btn btn-danger" onClick={deleteRecord}>
                                    Delete
                                </button>
                            </div>
                        </form>
                        {error && <p className="error-message">{error}</p>}
                    </div>
                </div>
            )}


            <div className="form-card">
                <h2>Add Record</h2>
                {addRecord && <p className="status-message">{addRecord}</p>}
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleAdd();
                    }}
                >
                    <div className="form-row">
                        <div className="form-group">
                            <label>Date</label>
                            <input
                                type="date"
                                name="data_op"
                                value={form2.data_op}
                                onChange={handleChangeAdd}
                            />
                        </div>
                        <button type="button" className="btn-today" onClick={setCurrentDate}>
                            Today
                        </button>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Amount</label>
                            <input
                                type="text"
                                name="amount"
                                value={form2.amount}
                                onChange={handleChangeAdd}
                                placeholder="0.00"
                            />
                        </div>
                        <div className="form-group">
                            <label>Currency</label>
                            <select
                                name="currency"
                                value={form2.currency}
                                onChange={handleChangeAdd}
                            >
                                <option value="RON">RON</option>
                                <option value="EUR">EUR</option>
                                <option value="USD">USD</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Category Name</label>
                        <input
                            type="text"
                            name="categ_name"
                            value={form2.categ_name}
                            onChange={handleChangeAdd}
                        />
                    </div>

                    <div className="form-group">
                        <label>Category Destination</label>
                        <input
                            type="text"
                            name="categ_dest"
                            value={form2.categ_dest}
                            onChange={handleChangeAdd}
                        />
                    </div>

                    <div className="form-group">
                        <label>Details</label>
                        <input
                            type="text"
                            name="details"
                            value={form2.details}
                            onChange={handleChangeAdd}
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Subcategory</label>
                            <input
                                type="text"
                                name="subcateg"
                                value={form2.subcateg}
                                onChange={handleChangeAdd}
                            />
                        </div>
                        <div className="form-group">
                            <label>Card</label>
                            <input
                                type="text"
                                name="card"
                                value={form2.card}
                                onChange={handleChangeAdd}
                            />
                        </div>
                    </div>

                    <div>
                        <button type="submit" className="btn btn-primary" disabled={isLoading}>
                            {isLoading ? "Adding..." : "Add Record"}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={clearAddValues}>
                            Cancel
                        </button>
                    </div>
                </form>
                {error && <p className="error-message">{error}</p>}
            </div>


            <select name="cheltSel" id="chelt-select" onChange={handleSelectChange} >
                <option value="">--Select--</option>
                {categories.map((item) => (
                    <option key={item.id} value={item.id}>{item.id + " : " + item.category}</option>

                ))}

            </select>

            <div className="table-container">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Date</th>
                            <th>Amount</th>
                            <th>Category</th>
                            <th>Cat ID</th>
                            <th>Destination</th>
                            <th>Details</th>
                            <th>Subcateg</th>
                            <th>Card</th>
                            <th>Currency</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item) => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.data_op}</td>
                                <td>{item.amount}</td>
                                <td>{item.categ_name}</td>
                                <td>{item.categ_id}</td>
                                <td>{item.categ_dest}</td>
                                <td>{item.details}</td>
                                <td>{item.subcateg}</td>
                                <td>{item.card}</td>
                                <td>{item.currency}</td>
                                <td><button className="btn-edit" onClick={() => handleEditClick(item)}>Edit</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>




        </div>
    );
}


export default MyCosts